import React from "react"
import { Helmet } from "react-helmet"

import { withMeta } from "./withMeta"

export const Meta = withMeta(
  ({ languages, metadata, metatags, schemas, googleSiteVerify }): JSX.Element => (
    <Helmet htmlAttributes={{ lang: metadata?.lang || "en" }} title={metadata?.title} meta={metatags}>
      <link href={metadata?.siteURL} rel="home" />
      <link href={metadata?.canonical} rel="canonical" />
      {languages?.map(({ href, hrefLang, rel }, index) => (
        <link key={index} href={href} hrefLang={hrefLang} rel={rel} />
      ))}
      {schemas.map((schema, index) => (
        <script type="application/ld+json" key={index}>
          {JSON.stringify(schema)}
        </script>
      ))}

      <meta name="p:domain_verify" content="5db8dfbd6c5ad0af0a9ac1b9c3b7d429" />
      <meta name={`google-site-verification`} content={googleSiteVerify} />

      <link href="https://d3hw6dc1ow8pp2.cloudfront.net/styles/main.min.css" rel="stylesheet" type="text/css" />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://dov7r31oq5dkj.cloudfront.net/568385c4-5eb5-458f-8441-63e2764a8d3f/widget-style-customisations.css?v=bc901fbb-4378-490c-88a8-27b716d902a4"
      />
      <script type="application/json" id="oke-reviews-settings">
        {JSON.stringify({
          disableInitialReviewsFetchOnProducts: false,
          filtersEnabled: false,
          initialReviewDisplayCount: 6,
          locale: "en",
          omitMicrodata: true,
          reviewSortOrder: "date",
          subscriberId: "568385c4-5eb5-458f-8441-63e2764a8d3f",
          widgetTemplateId: "minimal",
        })}
      </script>
    </Helmet>
  )
)
